import { BOOKING_DATA_CHANGE } from './actions';

export const INITIAL_STATE = {
  rooms: null,
  adults: null,
  check_in: null,
  check_out: null,
  city_id: null,
  hotel_id: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BOOKING_DATA_CHANGE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
